import { API, authClient } from "../index";

export const postSupplierType = async (supplierType, accessToken) => {
	return authClient(accessToken).post(`${API}/supplier-types`, supplierType);
};

export const getSupplierTypes = (accessToken) => {
	return authClient(accessToken).get(`${API}/supplier-types`);
};

export const getSupplierTypeById = (id, accessToken) => {
	return authClient(accessToken).get(`${API}/supplier-types/${id}`);
};

export const updateSupplierType = async (id, supplierType, accessToken) => {
	return authClient(accessToken).put(
		`${API}/supplier-types/${id}`,
		supplierType
	);
};

export const deleteSupplierType = (id, accessToken) => {
	return authClient(accessToken).delete(`${API}/supplier-types/${id}`);
};
